import React from 'react';
import { Link } from 'react-router-dom';

export default function PartnerListCard({ partner }) {
  const { slug, name, roleLabel, avatarLetter, heroImageUrl, facts = [], isFeatured } = partner;
  const previewFacts = facts.slice(0, 2);

  return (
    <Link to={`/partners/${slug}`} className="partner-list-card">
      <div
        className="partner-list-card-thumb"
        style={{ backgroundImage: `url('${heroImageUrl}')` }}
        aria-hidden="true"
      >
        {isFeatured ? <span className="partner-list-card-featured">Featured</span> : null}
      </div>
      <div className="partner-list-card-body">
        <div className="partner-list-card-head">
          <span className="partner-list-card-av" aria-hidden="true">
            {avatarLetter}
          </span>
          <div>
            <div className="partner-list-card-name">{name}</div>
            <div className="partner-list-card-role">{roleLabel}</div>
          </div>
        </div>
        {previewFacts.length ? (
          <div className="partner-list-card-facts">
            {previewFacts.map((fact) => (
              <span key={fact}>{fact}</span>
            ))}
          </div>
        ) : null}
        <span className="partner-list-card-cta">View builder →</span>
      </div>
    </Link>
  );
}
